import React, { useEffect, memo } from 'react';
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var PLATFORM_URL = 'https://static.elfsight.com/platform/platform.js';
function useLoadPlatform(modern) {
  useEffect(function () {
    var isPlatformLoaded = 'eapps' in window || !!document.querySelector("script[src=\"" + PLATFORM_URL + "\"]");
    if (isPlatformLoaded) {
      return;
    }
    var platfromScript = document.createElement('script');
    platfromScript.src = PLATFORM_URL;
    platfromScript.dataset.testid = 'platform-script';
    if (modern) {
      platfromScript.dataset.useServiceCore = '';
    }
    document.body.appendChild(platfromScript);
    // platform cannot be loaded twice on the sampe page
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
}
var _excluded = ["widgetId", "widgetID", "lazy", "modern", "className"];
var ElfsightWidget = /*#__PURE__*/memo(function ElfsightWidget(_ref) {
  var widgetId = _ref.widgetId,
    widgetID = _ref.widgetID,
    lazy = _ref.lazy,
    _ref$modern = _ref.modern,
    modern = _ref$modern === void 0 ? false : _ref$modern,
    className = _ref.className,
    forwardedProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(function () {
    if (widgetID) {
      console.debug('Note that widgetID is deprecated since version 1.1.0. Please use widgetId instead.');
    }
  }, [widgetID]);
  useLoadPlatform(modern);
  var finalWidgetId = widgetId !== null && widgetId !== void 0 ? widgetId : widgetID;
  var effectiveClassName = "elfsight-app-" + finalWidgetId;
  if (className) {
    effectiveClassName += " " + className;
  }
  var effectiveLazy;
  if (typeof lazy === 'boolean') {
    effectiveLazy = lazy ? 'default' : undefined;
  } else {
    effectiveLazy = lazy;
  }
  return React.createElement("div", Object.assign({
    className: effectiveClassName,
    "data-elfsight-app-lazy": effectiveLazy
  }, forwardedProps));
});
export { ElfsightWidget };